var map = {
	"./css/accordion.css": "c16b",
	"./css/authen.css": "adc3",
	"./css/bank-card.css": "2490",
	"./css/common_asset.css": "ba4c",
	"./css/footer.css": "46f5",
	"./css/gameiframe.css": "b018",
	"./css/index-login-full-screen.css": "e5a3",
	"./css/landing-page.css": "3313",
	"./css/main.css": "5aea",
	"./css/minor_css/proxy/bootstrap.min.css": "f341",
	"./css/minor_css/proxy/bootstrap.min.css.map": "b841",
	"./css/minor_css/proxy/proxy_style.css": "9269",
	"./css/my-mall.css": "9561",
	"./css/my_kyc.css": "8e8d",
	"./css/nav-login.css": "db7a",
	"./css/newLanding.css": "309b",
	"./css/popup.css": "c1b1",
	"./css/reset.css": "4ee2",
	"./css/style.css": "6672",
	"./css/useful_link.css": "cac3",
	"./css/vip.css": "b88a",
	"./theme_blue/images/9_gift.png": "aa87",
	"./theme_blue/images/Angle-left-g.png": "c08b",
	"./theme_blue/images/Angle-left.png": "193d",
	"./theme_blue/images/Angle-right-g.png": "2746",
	"./theme_blue/images/Angle-right.png": "59f2",
	"./theme_blue/images/BarbarianFury.png": "6b41",
	"./theme_blue/images/BattleDwarfXmas.png": "cd95",
	"./theme_blue/images/BoatBonanzaDownUnder.png": "9272",
	"./theme_blue/images/DragonKingHotPots.png": "607f",
	"./theme_blue/images/Ellipse.png": "7fed",
	"./theme_blue/images/H5_TOP.jpg": "21c0",
	"./theme_blue/images/HawaiianDreamXmas.png": "a11a",
	"./theme_blue/images/LogoLoading_circle01.png": "96ec",
	"./theme_blue/images/LogoLoading_circle02.png": "a16e",
	"./theme_blue/images/LogoLoading_katsu.png": "0d19",
	"./theme_blue/images/OiranDreamXmas.png": "bd80",
	"./theme_blue/images/PyramidRisingx33.png": "bcc2",
	"./theme_blue/images/RichWildeandtheTomeofInsanity.png": "20cd",
	"./theme_blue/images/SparkofGenius.png": "396b",
	"./theme_blue/images/Starstruck.png": "cae0",
	"./theme_blue/images/TheGoldenOwlofAthena.png": "bf21",
	"./theme_blue/images/TheSwordandtheGrailExcalibur.png": "d607",
	"./theme_blue/images/Withdraw-gold.svg": "1467",
	"./theme_blue/images/Withdraw-icon.svg": "208d",
	"./theme_blue/images/about_bg04.png": "53c3",
	"./theme_blue/images/add.svg": "eb9a",
	"./theme_blue/images/affiliates.png": "5df3",
	"./theme_blue/images/bankB-gold.svg": "3c48",
	"./theme_blue/images/bankB-icon.svg": "909d",
	"./theme_blue/images/bg-masthead-mb.png": "2ff6",
	"./theme_blue/images/bg-masthead.png": "0c74",
	"./theme_blue/images/bg_brush.png": "f344",
	"./theme_blue/images/bg_repeat.png": "71b4",
	"./theme_blue/images/bg_top.png": "0f0d",
	"./theme_blue/images/birth-bonus.png": "b3fc",
	"./theme_blue/images/bitcoin-btc-gold.svg": "3578",
	"./theme_blue/images/bitcoin-btc-logo.svg": "ca51",
	"./theme_blue/images/blog.png": "c9d8",
	"./theme_blue/images/bullhorn.svg": "4c46",
	"./theme_blue/images/cach-gold.svg": "e690",
	"./theme_blue/images/cach-icon.svg": "2c35",
	"./theme_blue/images/card-gold.svg": "fe01",
	"./theme_blue/images/card-icon.svg": "a000",
	"./theme_blue/images/ch_logo.png": "77a0",
	"./theme_blue/images/championship-bg.jpg": "2085",
	"./theme_blue/images/championship-main-event-bg.jpg": "b3c8",
	"./theme_blue/images/check-on.png": "adf9",
	"./theme_blue/images/cn_logo.png": "d399",
	"./theme_blue/images/collect.png": "e348",
	"./theme_blue/images/collect_full.png": "0ec9",
	"./theme_blue/images/comments-question.svg": "31f4",
	"./theme_blue/images/completed.png": "59c9",
	"./theme_blue/images/creditcard-back.png": "8015",
	"./theme_blue/images/creditcard-front.png": "0ade",
	"./theme_blue/images/crypto-ada.svg": "a787",
	"./theme_blue/images/crypto-bch.svg": "e33f",
	"./theme_blue/images/crypto-bnb.svg": "b84f",
	"./theme_blue/images/crypto-btc.svg": "9016",
	"./theme_blue/images/crypto-cny.svg": "2ac7",
	"./theme_blue/images/crypto-dai.svg": "9b0b",
	"./theme_blue/images/crypto-doge.svg": "767c",
	"./theme_blue/images/crypto-eos.svg": "d23c",
	"./theme_blue/images/crypto-eth.svg": "6694",
	"./theme_blue/images/crypto-jpy.svg": "6179",
	"./theme_blue/images/crypto-ltc.svg": "3eea",
	"./theme_blue/images/crypto-shib.svg": "7b79",
	"./theme_blue/images/crypto-teth.svg": "35c1",
	"./theme_blue/images/crypto-trx.svg": "9aeb",
	"./theme_blue/images/crypto-twd.svg": "2c1e",
	"./theme_blue/images/crypto-ubd.svg": "5bb8",
	"./theme_blue/images/crypto-usd.svg": "466f",
	"./theme_blue/images/crypto-usdc.svg": "a262",
	"./theme_blue/images/crypto-usdt.svg": "d541",
	"./theme_blue/images/crypto-xrp.svg": "1eff",
	"./theme_blue/images/daily-attend.png": "edf1",
	"./theme_blue/images/db_gift_left.png": "1c0e",
	"./theme_blue/images/db_gift_right.png": "fd3b",
	"./theme_blue/images/db_hero_img_mb.png": "f874",
	"./theme_blue/images/db_hero_img_pc.png": "7540",
	"./theme_blue/images/db_icon_coin.png": "60a1",
	"./theme_blue/images/db_icon_lock.png": "4c45",
	"./theme_blue/images/default-crypto.svg": "a945",
	"./theme_blue/images/deposit-gold.svg": "efe9",
	"./theme_blue/images/deposit-icon.svg": "cf92",
	"./theme_blue/images/dot-dk.svg": "ce77",
	"./theme_blue/images/dot-orange.svg": "7d63",
	"./theme_blue/images/dot.svg": "a2ba",
	"./theme_blue/images/dw.png": "99df",
	"./theme_blue/images/electron-gold.svg": "5c9a",
	"./theme_blue/images/electron-icon.svg": "5c32",
	"./theme_blue/images/email.svg": "a7ca",
	"./theme_blue/images/en_logo.png": "ed7b",
	"./theme_blue/images/event.png": "2ecea",
	"./theme_blue/images/event_specail_deposit_bg3.png": "0e47",
	"./theme_blue/images/favorite.png": "ef5f",
	"./theme_blue/images/footer_gaming1.png": "d010",
	"./theme_blue/images/footer_gaming2.png": "78cb",
	"./theme_blue/images/footer_gaming3.png": "cf9d",
	"./theme_blue/images/footer_gaming4.png": "bc63",
	"./theme_blue/images/fortunewheel.png": "a8e4",
	"./theme_blue/images/friend_promo.png": "84e1",
	"./theme_blue/images/giftbox.png": "ee20",
	"./theme_blue/images/headset.png": "a4c9",
	"./theme_blue/images/heart-line.svg": "8212",
	"./theme_blue/images/heart.svg": "2729",
	"./theme_blue/images/history.png": "2ee9",
	"./theme_blue/images/home-arrow-left.png": "1265",
	"./theme_blue/images/home-arrow-right.png": "4f1b",
	"./theme_blue/images/icon-account.png": "dc1d",
	"./theme_blue/images/icon-add.png": "c94d",
	"./theme_blue/images/icon-alert-kyc.png": "e22b",
	"./theme_blue/images/icon-alert.png": "4676",
	"./theme_blue/images/icon-arrow-down-2.png": "04bb",
	"./theme_blue/images/icon-arrow-down-3.png": "a368",
	"./theme_blue/images/icon-arrow-down-4-disabled.png": "4d8f",
	"./theme_blue/images/icon-arrow-down-4.png": "49d4",
	"./theme_blue/images/icon-arrow-down-gold.png": "ecf8",
	"./theme_blue/images/icon-arrow-down.png": "0c03",
	"./theme_blue/images/icon-arrow-dropdown.png": "64a6",
	"./theme_blue/images/icon-arrow-right.png": "825b",
	"./theme_blue/images/icon-arrow-rightx2.png": "f434",
	"./theme_blue/images/icon-check-black.png": "3f19",
	"./theme_blue/images/icon-check.png": "3a3f",
	"./theme_blue/images/icon-checked.png": "ba39",
	"./theme_blue/images/icon-close-black.png": "c99a",
	"./theme_blue/images/icon-close.png": "6934",
	"./theme_blue/images/icon-close_index_phone.png": "7568",
	"./theme_blue/images/icon-coin.png": "ca70",
	"./theme_blue/images/icon-copy-2.png": "b5ce",
	"./theme_blue/images/icon-copy.png": "c17c",
	"./theme_blue/images/icon-credit.png": "09ac",
	"./theme_blue/images/icon-crown.png": "a5d7",
	"./theme_blue/images/icon-date.png": "1d90",
	"./theme_blue/images/icon-detail.png": "6b4d",
	"./theme_blue/images/icon-diamond.png": "72dc",
	"./theme_blue/images/icon-download.png": "b4a7",
	"./theme_blue/images/icon-edit-dark.png": "6510",
	"./theme_blue/images/icon-edit-fill.png": "0755",
	"./theme_blue/images/icon-expand-w.png": "3d7b",
	"./theme_blue/images/icon-favorite-active.png": "41dc",
	"./theme_blue/images/icon-favorite.png": "d754",
	"./theme_blue/images/icon-filter.png": "81e9",
	"./theme_blue/images/icon-flag.png": "51b7",
	"./theme_blue/images/icon-game-search.png": "20f1",
	"./theme_blue/images/icon-home.png": "6779",
	"./theme_blue/images/icon-info.png": "4a80",
	"./theme_blue/images/icon-invite-bonus.png": "d48c",
	"./theme_blue/images/icon-invite-promo.png": "2707",
	"./theme_blue/images/icon-invite-weekly.png": "67b1",
	"./theme_blue/images/icon-kyc-add.png": "66f0",
	"./theme_blue/images/icon-kyc-close.png": "7c01",
	"./theme_blue/images/icon-kyc-open.png": "2732",
	"./theme_blue/images/icon-lock.png": "90c6",
	"./theme_blue/images/icon-member-active.png": "c2bf",
	"./theme_blue/images/icon-member.png": "f115",
	"./theme_blue/images/icon-nav-home.png": "1c34",
	"./theme_blue/images/icon-news-w.png": "3325",
	"./theme_blue/images/icon-notice.png": "2347",
	"./theme_blue/images/icon-password.png": "ef73",
	"./theme_blue/images/icon-phone-active.png": "8297",
	"./theme_blue/images/icon-phone.png": "b743",
	"./theme_blue/images/icon-qrcode.png": "21ef",
	"./theme_blue/images/icon-real-name.png": "b9d2",
	"./theme_blue/images/icon-recommend.png": "4fa8",
	"./theme_blue/images/icon-refresh.png": "74aa",
	"./theme_blue/images/icon-register-success.png": "2fc0",
	"./theme_blue/images/icon-search.png": "3fc0",
	"./theme_blue/images/icon-slot-select.png": "f370",
	"./theme_blue/images/icon-slot.png": "32fb",
	"./theme_blue/images/icon-top-arrow.svg": "6f03",
	"./theme_blue/images/icon-usdt.png": "f861",
	"./theme_blue/images/icon_alert.png": "9121",
	"./theme_blue/images/icon_allgames.png": "ad5d",
	"./theme_blue/images/icon_awesome_bitcoin.png": "a511",
	"./theme_blue/images/icon_bell.png": "19b8",
	"./theme_blue/images/icon_bonus.svg": "9595",
	"./theme_blue/images/icon_calendar_light.png": "5b0f",
	"./theme_blue/images/icon_card_light.png": "1478",
	"./theme_blue/images/icon_check_white.png": "0941",
	"./theme_blue/images/icon_close.png": "fbe6",
	"./theme_blue/images/icon_copy_regular.png": "4269",
	"./theme_blue/images/icon_copy_white.png": "334a",
	"./theme_blue/images/icon_download_white.png": "0705",
	"./theme_blue/images/icon_email.png": "acf9",
	"./theme_blue/images/icon_ig.png": "df04",
	"./theme_blue/images/icon_img_01.png": "cf2c",
	"./theme_blue/images/icon_img_03.png": "8549",
	"./theme_blue/images/icon_img_04.png": "05d0",
	"./theme_blue/images/icon_img_05.png": "659f",
	"./theme_blue/images/icon_img_06.png": "8cd0",
	"./theme_blue/images/icon_img_07.png": "094e",
	"./theme_blue/images/icon_img_08.png": "c4c4",
	"./theme_blue/images/icon_img_09.png": "d317",
	"./theme_blue/images/icon_img_10.png": "6dfe",
	"./theme_blue/images/icon_img_11.png": "112c",
	"./theme_blue/images/icon_img_12.png": "1576",
	"./theme_blue/images/icon_img_13.png": "3999",
	"./theme_blue/images/icon_img_14.png": "935e",
	"./theme_blue/images/icon_img_15.png": "a8c2",
	"./theme_blue/images/icon_japan.png": "65ce",
	"./theme_blue/images/icon_jpy.png": "d873",
	"./theme_blue/images/icon_jpy.svg": "a2bd",
	"./theme_blue/images/icon_lock_light.png": "aa19",
	"./theme_blue/images/icon_metro_credit_card.png": "85dd",
	"./theme_blue/images/icon_payment_bankomat.png": "a366",
	"./theme_blue/images/icon_promo_check.png": "c2b1",
	"./theme_blue/images/icon_promo_check_v2.png": "fd20",
	"./theme_blue/images/icon_shield_gray.png": "9bd1",
	"./theme_blue/images/icon_simple_electron.png": "7d0b",
	"./theme_blue/images/icon_tab_favorite.png": "326c",
	"./theme_blue/images/icon_tag_hot.png": "a1e9",
	"./theme_blue/images/icon_tag_new.png": "f098",
	"./theme_blue/images/icon_tag_noBonus.png": "7bc1",
	"./theme_blue/images/icon_trash.png": "e54c",
	"./theme_blue/images/icon_twitter.png": "921d",
	"./theme_blue/images/icon_uestion.svg": "1a9d",
	"./theme_blue/images/icon_usd.svg": "5ac4",
	"./theme_blue/images/icon_user_light.png": "42c8",
	"./theme_blue/images/icon_youtube.png": "9459",
	"./theme_blue/images/image-bank.png": "109c",
	"./theme_blue/images/image-upload.png": "0543",
	"./theme_blue/images/instruction.png": "0c13",
	"./theme_blue/images/iocn-trash-fill.png": "04c5",
	"./theme_blue/images/japan.png": "22ae",
	"./theme_blue/images/jp-yen.svg": "fe58",
	"./theme_blue/images/jp_logo.png": "6725",
	"./theme_blue/images/leave.png": "2f48",
	"./theme_blue/images/lights_m.png": "d980",
	"./theme_blue/images/live.png": "5c87",
	"./theme_blue/images/login-left-2.jpg": "abee",
	"./theme_blue/images/login-left.jpg": "8d17",
	"./theme_blue/images/login-left.png": "d4ed",
	"./theme_blue/images/login-logo-2-mb.jpg": "cae3",
	"./theme_blue/images/login-logo.jpg": "520a",
	"./theme_blue/images/logo-2.webp": "5321",
	"./theme_blue/images/logo.png": "bf11",
	"./theme_blue/images/logo_ft.png": "28f3",
	"./theme_blue/images/logo_katsuwin.png": "d68c",
	"./theme_blue/images/lpfv-pc-2000.png": "b0b3",
	"./theme_blue/images/lpfv-pc-3000.png": "4f1c",
	"./theme_blue/images/lpfv-pc-4000.png": "78f4",
	"./theme_blue/images/lpfv-pc-5000.png": "7afc",
	"./theme_blue/images/lpfv-pc.png": "33ff",
	"./theme_blue/images/lpfv-sp-2000.png": "bc7f",
	"./theme_blue/images/lpfv-sp-3000.png": "86b0",
	"./theme_blue/images/lpfv-sp-4000.png": "e92d",
	"./theme_blue/images/lpfv-sp-5000.png": "0870",
	"./theme_blue/images/lpfv-sp.png": "d985",
	"./theme_blue/images/main_bg.jpg": "ca58",
	"./theme_blue/images/mall-invite-image.png": "5a3e",
	"./theme_blue/images/mall-product-image.png": "e2e0",
	"./theme_blue/images/money_pop.png": "8240",
	"./theme_blue/images/monthly-bonus.png": "1818",
	"./theme_blue/images/monyback-gold.svg": "95f4",
	"./theme_blue/images/monyback-icon.svg": "e0a5",
	"./theme_blue/images/my-account.png": "0dd3",
	"./theme_blue/images/my_kyc_ex1.png": "94d5",
	"./theme_blue/images/my_kyc_ex2.webp": "133a",
	"./theme_blue/images/nav-bottom-deposit-active.png": "4355",
	"./theme_blue/images/nav-bottom-deposit.png": "4a9a",
	"./theme_blue/images/nav-bottom-game-active.png": "7616",
	"./theme_blue/images/nav-bottom-game.png": "fd6d",
	"./theme_blue/images/nav-bottom-home-active.png": "8d44",
	"./theme_blue/images/nav-bottom-home-mobile-index.png": "189f",
	"./theme_blue/images/nav-bottom-home.png": "27af",
	"./theme_blue/images/nav-bottom-my-active.png": "c6fc",
	"./theme_blue/images/nav-bottom-my.png": "faeb",
	"./theme_blue/images/nav-bottom-offers-active.png": "b963",
	"./theme_blue/images/nav-bottom-offers.png": "ad6b",
	"./theme_blue/images/nav-bottom-toggle.png": "28a4",
	"./theme_blue/images/new_guide.png": "43a0",
	"./theme_blue/images/no-data.png": "5dae",
	"./theme_blue/images/no.svg": "c843",
	"./theme_blue/images/oncasy_logo.png": "1325",
	"./theme_blue/images/pachislot.png": "2b62",
	"./theme_blue/images/personal_data_ad.png": "a949",
	"./theme_blue/images/program.png": "f2ee",
	"./theme_blue/images/rank-1st.png": "5aab",
	"./theme_blue/images/rank-2nd.png": "004d",
	"./theme_blue/images/rank-3rd.png": "583d",
	"./theme_blue/images/rebate-bonus.png": "ba7c",
	"./theme_blue/images/register-bg.jpg": "c6a6",
	"./theme_blue/images/register-logo-pc.jpg": "1238",
	"./theme_blue/images/register-logo.jpg": "9ca8",
	"./theme_blue/images/register-logo.png": "5e88",
	"./theme_blue/images/registration-2000.png": "cd8f",
	"./theme_blue/images/registration-3000.png": "32d2",
	"./theme_blue/images/registration-4000.png": "9752",
	"./theme_blue/images/registration-5000.png": "9466",
	"./theme_blue/images/registration.png": "8d8b",
	"./theme_blue/images/shop.png": "c578",
	"./theme_blue/images/skill.png": "e472",
	"./theme_blue/images/slots.png": "07ce",
	"./theme_blue/images/spin_wheel_bg_lt.png": "8d72",
	"./theme_blue/images/spin_wheel_bg_rt.png": "72e0",
	"./theme_blue/images/stake-logo.png": "a7ad",
	"./theme_blue/images/structure01.png": "2e64",
	"./theme_blue/images/structure01.svg": "48dd",
	"./theme_blue/images/structure02.png": "9008",
	"./theme_blue/images/structure02.svg": "ef46",
	"./theme_blue/images/structure03.png": "f511",
	"./theme_blue/images/structure03.svg": "c1bd",
	"./theme_blue/images/sup/account_mb_01.jpg": "dc16",
	"./theme_blue/images/sup/account_mb_02.jpg": "e129",
	"./theme_blue/images/sup/account_mb_03.jpg": "eaa5",
	"./theme_blue/images/sup/account_mb_03.png": "5276",
	"./theme_blue/images/sup/account_mb_04.jpg": "aad3",
	"./theme_blue/images/sup/account_mb_05.jpg": "6731",
	"./theme_blue/images/sup/account_pc_01.png": "72c0",
	"./theme_blue/images/sup/account_pc_02.png": "e295",
	"./theme_blue/images/sup/account_pc_03.png": "c72d",
	"./theme_blue/images/sup/account_pc_04.webp": "43b9",
	"./theme_blue/images/sup/account_pc_05.png": "e187",
	"./theme_blue/images/sup/account_pc_06.png": "428d",
	"./theme_blue/images/sup/account_pc_07.png": "13a8",
	"./theme_blue/images/sup/account_pc_08.png": "3d87",
	"./theme_blue/images/sup/binding_mb_tab_01.png": "ba72",
	"./theme_blue/images/sup/binding_mb_tab_02.png": "588c",
	"./theme_blue/images/sup/binding_mb_tab_03.png": "37a6",
	"./theme_blue/images/sup/binding_mb_tab_04.png": "e567",
	"./theme_blue/images/sup/binding_mb_tab_05.png": "e831",
	"./theme_blue/images/sup/binding_mb_tab_06.png": "6290",
	"./theme_blue/images/sup/binding_pc_tab_01.png": "47f5",
	"./theme_blue/images/sup/binding_pc_tab_02.png": "ab57",
	"./theme_blue/images/sup/binding_pc_tab_03.png": "9933",
	"./theme_blue/images/sup/binding_pc_tab_04.png": "a5fe",
	"./theme_blue/images/sup/binding_pc_tab_05.png": "419b",
	"./theme_blue/images/sup/binding_pc_tab_06.png": "ee53",
	"./theme_blue/images/sup/confirmID_2-2.webp": "a39e",
	"./theme_blue/images/sup/coupon_mb_tab_01.png": "02ae",
	"./theme_blue/images/sup/coupon_mb_tab_02.png": "0809",
	"./theme_blue/images/sup/coupon_pc_tab_01.png": "838e",
	"./theme_blue/images/sup/coupon_pc_tab_02.png": "923f",
	"./theme_blue/images/sup/event_mb_tab_01.png": "a37d",
	"./theme_blue/images/sup/event_mb_tab_02.png": "8fbc",
	"./theme_blue/images/sup/event_mb_tab_03.png": "04ab",
	"./theme_blue/images/sup/event_pc_tab_01.png": "203a",
	"./theme_blue/images/sup/event_pc_tab_02.png": "b862",
	"./theme_blue/images/sup/event_pc_tab_03.png": "1b40",
	"./theme_blue/images/sup/login_tab01_01.png": "1654",
	"./theme_blue/images/sup/login_tab01_02.png": "e3b8",
	"./theme_blue/images/sup/login_tab01_03.png": "753b",
	"./theme_blue/images/sup/login_tab01_04.png": "7ef0",
	"./theme_blue/images/sup/login_tab01_05.png": "af58",
	"./theme_blue/images/sup/login_tab02_02.png": "fdc8",
	"./theme_blue/images/sup/login_tab02_03.png": "03b4",
	"./theme_blue/images/sup/login_tab02_04.png": "b317",
	"./theme_blue/images/sup/login_tab02_05.png": "99c7",
	"./theme_blue/images/sup/login_tab03_01.png": "4f89",
	"./theme_blue/images/sup/login_tab03_02.png": "f40e",
	"./theme_blue/images/sup/login_tab03_03.png": "e288",
	"./theme_blue/images/sup/login_tab03_04.png": "cb9f",
	"./theme_blue/images/sup/login_tab03_05.png": "8657",
	"./theme_blue/images/sup/login_tab04_02.png": "0d9b",
	"./theme_blue/images/sup/login_tab04_03.png": "80dd",
	"./theme_blue/images/sup/login_tab04_04.png": "71b9",
	"./theme_blue/images/sup/login_tab04_05.png": "0e45",
	"./theme_blue/images/sup/payment_mb_01.png": "7f3c",
	"./theme_blue/images/sup/payment_mb_02.png": "b4d9",
	"./theme_blue/images/sup/payment_mb_03.png": "17fd",
	"./theme_blue/images/sup/payment_mb_04.png": "3f3f",
	"./theme_blue/images/sup/payment_mb_05.png": "91fc",
	"./theme_blue/images/sup/payment_mb_06.png": "0b90",
	"./theme_blue/images/sup/payment_mb_07.png": "d4f2",
	"./theme_blue/images/sup/payment_mb_08.png": "465f",
	"./theme_blue/images/sup/payment_mb_09.png": "1971",
	"./theme_blue/images/sup/payment_mb_10.png": "39c6",
	"./theme_blue/images/sup/payment_mb_11.png": "12bf",
	"./theme_blue/images/sup/payment_pc_01.png": "9034",
	"./theme_blue/images/sup/payment_pc_02.png": "3457",
	"./theme_blue/images/sup/payment_pc_03.png": "3aae",
	"./theme_blue/images/sup/payment_pc_04.png": "ca78",
	"./theme_blue/images/sup/payment_pc_05.png": "5dc4",
	"./theme_blue/images/sup/payment_pc_06.png": "bf96",
	"./theme_blue/images/sup/payment_pc_07.png": "c929",
	"./theme_blue/images/sup/payment_pc_08.png": "d80f",
	"./theme_blue/images/sup/payment_pc_09.png": "5347",
	"./theme_blue/images/sup/payment_pc_10.png": "a75e",
	"./theme_blue/images/sup/payment_pc_11.png": "3ec9",
	"./theme_blue/images/sup/payment_pc_12.png": "cb3b",
	"./theme_blue/images/sup/pc_banner_sup_acc.webp": "79df",
	"./theme_blue/images/sup/pc_banner_sup_accout.webp": "98f3",
	"./theme_blue/images/sup/pc_banner_sup_coupon.webp": "bf70",
	"./theme_blue/images/sup/pc_banner_sup_event.webp": "729f",
	"./theme_blue/images/sup/pc_banner_sup_faq.webp": "ebd5",
	"./theme_blue/images/sup/pc_banner_sup_faq_k.webp": "ae37",
	"./theme_blue/images/sup/pc_banner_sup_login.webp": "ea89",
	"./theme_blue/images/sup/pc_banner_sup_pay.webp": "6f9b",
	"./theme_blue/images/sup/pc_banner_sup_recommend.webp": "987e",
	"./theme_blue/images/sup/pc_banner_sup_responsible.webp": "a546",
	"./theme_blue/images/sup/pc_banner_sup_shop.webp": "46da",
	"./theme_blue/images/sup/pc_banner_sup_vip.webp": "78f0",
	"./theme_blue/images/sup/pc_banner_sup_wallet.webp": "3e86",
	"./theme_blue/images/sup/recommended_01.webp": "975c",
	"./theme_blue/images/sup/recommended_02.webp": "c970",
	"./theme_blue/images/sup/recommended_03.webp": "b2d2",
	"./theme_blue/images/sup/recommended_04.webp": "eea2",
	"./theme_blue/images/sup/recommended_05.webp": "bfb7",
	"./theme_blue/images/sup/register_mb_01.png": "d337",
	"./theme_blue/images/sup/register_mb_02.png": "a09d",
	"./theme_blue/images/sup/register_mb_03.png": "ba89",
	"./theme_blue/images/sup/register_mb_04.png": "7efd",
	"./theme_blue/images/sup/register_mb_05.png": "5c58",
	"./theme_blue/images/sup/register_pc_01.png": "da57",
	"./theme_blue/images/sup/register_pc_02.png": "4d63",
	"./theme_blue/images/sup/register_pc_03.png": "5053",
	"./theme_blue/images/sup/register_pc_04.png": "60d5",
	"./theme_blue/images/sup/register_pc_05.png": "1e94",
	"./theme_blue/images/sup/shop_mb_tab_01.png": "b2ec",
	"./theme_blue/images/sup/shop_mb_tab_02.png": "872c",
	"./theme_blue/images/sup/shop_pc_tab_01.png": "d636",
	"./theme_blue/images/sup/shop_pc_tab_02.png": "81fd",
	"./theme_blue/images/sup/table.png": "501c",
	"./theme_blue/images/sup/vip_mb_tab_01.png": "1ba6",
	"./theme_blue/images/sup/vip_mb_tab_02.png": "3c1c",
	"./theme_blue/images/sup/vip_mb_tab_03.png": "a2e2",
	"./theme_blue/images/sup/vip_pc_tab_01.png": "ae53",
	"./theme_blue/images/sup/vip_pc_tab_02.png": "2740",
	"./theme_blue/images/sup/wallet_mb_01.png": "dae6",
	"./theme_blue/images/sup/wallet_mb_02.png": "6470",
	"./theme_blue/images/sup/wallet_mb_03.png": "3b20",
	"./theme_blue/images/sup/wallet_mb_04.png": "6c29",
	"./theme_blue/images/sup/wallet_mb_05.png": "09e1",
	"./theme_blue/images/sup/wallet_mb_06.png": "4e87",
	"./theme_blue/images/sup/wallet_pc_01.png": "6b4f",
	"./theme_blue/images/sup/wallet_pc_02.png": "5210",
	"./theme_blue/images/sup/wallet_pc_03.png": "5f0f",
	"./theme_blue/images/sup/wallet_pc_04.png": "2f1d",
	"./theme_blue/images/sup/wallet_pc_05.png": "35d2",
	"./theme_blue/images/sup/wallet_pc_06.png": "0f3a",
	"./theme_blue/images/sup/wallet_pc_07.png": "15c2",
	"./theme_blue/images/sup/wallet_pc_08.png": "2044",
	"./theme_blue/images/terms-bg.png": "b933",
	"./theme_blue/images/title-championship.png": "8b3d",
	"./theme_blue/images/top10-bn.png": "10d7",
	"./theme_blue/images/top10-bn2.png": "3baa",
	"./theme_blue/images/top_up.png": "52e6",
	"./theme_blue/images/trophy-gold.svg": "71cb",
	"./theme_blue/images/trophy-icon.svg": "2b4e",
	"./theme_blue/images/useful_link/agent_five.webp": "3caf",
	"./theme_blue/images/useful_link/agent_four.webp": "4ad9",
	"./theme_blue/images/useful_link/agent_one.webp": "d600",
	"./theme_blue/images/useful_link/agent_three.webp": "9e22",
	"./theme_blue/images/useful_link/agent_two.webp": "c29a",
	"./theme_blue/images/useful_link/agent_validSeal.webp": "b7bc",
	"./theme_blue/images/useful_link/bg.jpg": "9a5d",
	"./theme_blue/images/useful_link/bonusIntroducing.webp": "f166",
	"./theme_blue/images/useful_link/how_to_join_1.webp": "537a",
	"./theme_blue/images/useful_link/how_to_join_2.webp": "bdcd",
	"./theme_blue/images/useful_link/how_to_join_3.webp": "9ad5",
	"./theme_blue/images/useful_link/icon_FAQ.png": "af65",
	"./theme_blue/images/useful_link/icon_account_binding.png": "4516",
	"./theme_blue/images/useful_link/icon_confirm_method.png": "641e",
	"./theme_blue/images/useful_link/icon_coupon.png": "e093",
	"./theme_blue/images/useful_link/icon_deposit_withdraw.png": "cc7f",
	"./theme_blue/images/useful_link/icon_event_bonus.png": "8112",
	"./theme_blue/images/useful_link/icon_login.png": "0888",
	"./theme_blue/images/useful_link/icon_login_method.png": "0215",
	"./theme_blue/images/useful_link/icon_recommended_games.png": "bca9",
	"./theme_blue/images/useful_link/icon_self_restriction.png": "d7fc",
	"./theme_blue/images/useful_link/icon_shop.png": "1b36",
	"./theme_blue/images/useful_link/icon_vip_class_upgrading.png": "6369",
	"./theme_blue/images/useful_link/icon_wallet.png": "99af",
	"./theme_blue/images/useful_link/pc_banner_agent.jpeg": "b8d3",
	"./theme_blue/images/useful_link/pc_banner_cookie.jpeg": "7354",
	"./theme_blue/images/useful_link/pc_banner_cooperation.jpeg": "cea4",
	"./theme_blue/images/useful_link/pc_banner_cooperation.jpg": "f6d7",
	"./theme_blue/images/useful_link/pc_banner_privacy.jpeg": "0b17",
	"./theme_blue/images/useful_link/pc_banner_rule.jpeg": "5f99",
	"./theme_blue/images/useful_link/pc_banner_sport.jpeg": "3cd5",
	"./theme_blue/images/useful_link/pc_banner_support.jpeg": "df34",
	"./theme_blue/images/useful_link/pc_banner_support.png": "8e49",
	"./theme_blue/images/useful_link/pc_banner_terms.png": "1249",
	"./theme_blue/images/useful_link/permanentIncome.webp": "3e2c",
	"./theme_blue/images/vector.svg": "c359",
	"./theme_blue/images/verify.png": "4a7c",
	"./theme_blue/images/vip-24-hours.png": "d4ed9",
	"./theme_blue/images/vip-arrow-left.png": "6872",
	"./theme_blue/images/vip-arrow-right.png": "bf03",
	"./theme_blue/images/vip-bg.jpg": "c44a",
	"./theme_blue/images/vip-bonus.png": "9062",
	"./theme_blue/images/vip-coin-stack.png": "d440",
	"./theme_blue/images/vip-crown.png": "bb7b",
	"./theme_blue/images/vip-green-line.png": "530e",
	"./theme_blue/images/vip-roulette.png": "6bd9",
	"./theme_blue/images/vip-wallet.png": "0977",
	"./theme_blue/images/vip.png": "f681",
	"./theme_blue/images/vip_bg.jpg": "8a65",
	"./theme_blue/images/vip_bg.png": "08bb",
	"./theme_blue/images/vip_gift_bg.png": "22b0",
	"./theme_blue/images/wallet.png": "f226",
	"./theme_blue/images/web_TOP.png": "411f",
	"./theme_blue/images/weekly-bonus.png": "3384",
	"./theme_blue/images/wheel_2x.png": "4530",
	"./theme_blue/variables.css": "78b0",
	"./theme_gold/images/9_gift.png": "c68c",
	"./theme_gold/images/Angle-left-g.png": "7294",
	"./theme_gold/images/Angle-left.png": "407c",
	"./theme_gold/images/Angle-right-g.png": "6363",
	"./theme_gold/images/Angle-right.png": "7040",
	"./theme_gold/images/BarbarianFury.png": "92a6",
	"./theme_gold/images/BattleDwarfXmas.png": "23b7",
	"./theme_gold/images/BoatBonanzaDownUnder.png": "9d98",
	"./theme_gold/images/DragonKingHotPots.png": "b099",
	"./theme_gold/images/Ellipse.png": "efd7",
	"./theme_gold/images/H5_TOP.jpg": "4ac0",
	"./theme_gold/images/HawaiianDreamXmas.png": "e196",
	"./theme_gold/images/LogoLoading_circle01.png": "8fe7",
	"./theme_gold/images/LogoLoading_circle02.png": "0b79",
	"./theme_gold/images/LogoLoading_katsu.png": "bf62",
	"./theme_gold/images/OiranDreamXmas.png": "6549",
	"./theme_gold/images/PyramidRisingx33.png": "1739",
	"./theme_gold/images/RichWildeandtheTomeofInsanity.png": "f06a",
	"./theme_gold/images/SparkofGenius.png": "0cc0",
	"./theme_gold/images/Starstruck.png": "7f34",
	"./theme_gold/images/TheGoldenOwlofAthena.png": "030e",
	"./theme_gold/images/TheSwordandtheGrailExcalibur.png": "bbeb",
	"./theme_gold/images/Withdraw-gold.svg": "171d",
	"./theme_gold/images/Withdraw-icon.svg": "4d29",
	"./theme_gold/images/about_bg04.png": "0ae5",
	"./theme_gold/images/add.svg": "00f8",
	"./theme_gold/images/affiliates.png": "027e",
	"./theme_gold/images/bankB-gold.svg": "a442",
	"./theme_gold/images/bankB-icon.svg": "1023",
	"./theme_gold/images/bg-masthead-mb.png": "3128",
	"./theme_gold/images/bg-masthead.png": "45df",
	"./theme_gold/images/bg_brush.png": "ad51",
	"./theme_gold/images/bg_repeat.png": "a63dc",
	"./theme_gold/images/bg_top.png": "7453",
	"./theme_gold/images/birth-bonus.png": "ae80",
	"./theme_gold/images/bitcoin-btc-gold.svg": "2ece",
	"./theme_gold/images/bitcoin-btc-logo.svg": "e7ed",
	"./theme_gold/images/blog.png": "bb49",
	"./theme_gold/images/bullhorn.svg": "1497",
	"./theme_gold/images/cach-gold.svg": "3d0e",
	"./theme_gold/images/cach-icon.svg": "70a4",
	"./theme_gold/images/card-gold.svg": "7597",
	"./theme_gold/images/card-icon.svg": "a316",
	"./theme_gold/images/ch_logo.png": "1f60",
	"./theme_gold/images/championship-bg.jpg": "6480",
	"./theme_gold/images/championship-main-event-bg.jpg": "0c0c",
	"./theme_gold/images/check-on.png": "aac5",
	"./theme_gold/images/cn_logo.png": "f391",
	"./theme_gold/images/collect.png": "987c",
	"./theme_gold/images/collect_full.png": "14c4",
	"./theme_gold/images/comments-question.svg": "a918",
	"./theme_gold/images/completed.png": "a921",
	"./theme_gold/images/creditcard-back.png": "f6ab",
	"./theme_gold/images/creditcard-front.png": "78c8",
	"./theme_gold/images/crypto-ada.svg": "f014",
	"./theme_gold/images/crypto-bch.svg": "604f",
	"./theme_gold/images/crypto-bnb.svg": "ea95",
	"./theme_gold/images/crypto-btc.svg": "8555",
	"./theme_gold/images/crypto-cny.svg": "31ff",
	"./theme_gold/images/crypto-dai.svg": "f1cc",
	"./theme_gold/images/crypto-doge.svg": "a829",
	"./theme_gold/images/crypto-eos.svg": "3f53",
	"./theme_gold/images/crypto-eth.svg": "0ecc",
	"./theme_gold/images/crypto-jpy.svg": "c760",
	"./theme_gold/images/crypto-ltc.svg": "3739",
	"./theme_gold/images/crypto-shib.svg": "9d9c",
	"./theme_gold/images/crypto-teth.svg": "d07c",
	"./theme_gold/images/crypto-trx.svg": "8e2c",
	"./theme_gold/images/crypto-twd.svg": "ea77",
	"./theme_gold/images/crypto-usd.svg": "3602",
	"./theme_gold/images/crypto-usdc.svg": "a711",
	"./theme_gold/images/crypto-usdt.svg": "6fb5",
	"./theme_gold/images/crypto-xrp.svg": "5d3f",
	"./theme_gold/images/daily-attend.png": "d3ab",
	"./theme_gold/images/db_gift_left.png": "d01c",
	"./theme_gold/images/db_gift_right.png": "5744",
	"./theme_gold/images/db_hero_img_mb.png": "c127",
	"./theme_gold/images/db_hero_img_pc.png": "104d",
	"./theme_gold/images/db_icon_coin.png": "5b5c",
	"./theme_gold/images/db_icon_lock.png": "4e5e",
	"./theme_gold/images/default-crypto.svg": "16ef",
	"./theme_gold/images/deposit-gold.svg": "60aa",
	"./theme_gold/images/deposit-icon.svg": "3c1b",
	"./theme_gold/images/dot-dk.svg": "94d4",
	"./theme_gold/images/dot-orange.svg": "ada5",
	"./theme_gold/images/dot.svg": "4f38",
	"./theme_gold/images/dw.png": "c1d3",
	"./theme_gold/images/electron-gold.svg": "f8a1",
	"./theme_gold/images/electron-icon.svg": "082a",
	"./theme_gold/images/email.svg": "b4d8",
	"./theme_gold/images/en_logo.png": "4d1a",
	"./theme_gold/images/event.png": "d8d7",
	"./theme_gold/images/event_specail_deposit_bg3.png": "462e",
	"./theme_gold/images/favorite.png": "f533",
	"./theme_gold/images/footer_gaming1.png": "2398",
	"./theme_gold/images/footer_gaming2.png": "8058",
	"./theme_gold/images/footer_gaming3.png": "890e",
	"./theme_gold/images/footer_gaming4.png": "18b2",
	"./theme_gold/images/fortunewheel.png": "c281",
	"./theme_gold/images/friend_promo.png": "f7ff",
	"./theme_gold/images/giftbox.png": "4db4",
	"./theme_gold/images/headset.png": "550d",
	"./theme_gold/images/heart-line.svg": "343e",
	"./theme_gold/images/heart.svg": "5fe9",
	"./theme_gold/images/history.png": "89d8",
	"./theme_gold/images/home-arrow-left.png": "914e",
	"./theme_gold/images/home-arrow-right.png": "4bb9",
	"./theme_gold/images/icon-account.png": "1dc5",
	"./theme_gold/images/icon-add.png": "dab3",
	"./theme_gold/images/icon-alert-kyc.png": "d9bc",
	"./theme_gold/images/icon-alert.png": "bc92",
	"./theme_gold/images/icon-arrow-down-2.png": "3e9b",
	"./theme_gold/images/icon-arrow-down-3.png": "a110",
	"./theme_gold/images/icon-arrow-down-4-disabled.png": "8a77",
	"./theme_gold/images/icon-arrow-down-4.png": "7b08",
	"./theme_gold/images/icon-arrow-down-gold.png": "ab44",
	"./theme_gold/images/icon-arrow-down.png": "b346",
	"./theme_gold/images/icon-arrow-dropdown.png": "d851",
	"./theme_gold/images/icon-arrow-right.png": "28fb",
	"./theme_gold/images/icon-arrow-rightx2.png": "dffd",
	"./theme_gold/images/icon-check-black.png": "bf968",
	"./theme_gold/images/icon-check.png": "cac4",
	"./theme_gold/images/icon-checked.png": "b407",
	"./theme_gold/images/icon-close-black.png": "ed52",
	"./theme_gold/images/icon-close.png": "4297",
	"./theme_gold/images/icon-close_index_phone.png": "b998",
	"./theme_gold/images/icon-coin.png": "2879",
	"./theme_gold/images/icon-copy-2.png": "9df4",
	"./theme_gold/images/icon-copy.png": "96f0",
	"./theme_gold/images/icon-credit.png": "93c0",
	"./theme_gold/images/icon-crown.png": "6cb3",
	"./theme_gold/images/icon-date.png": "1e05",
	"./theme_gold/images/icon-detail.png": "61c1",
	"./theme_gold/images/icon-diamond.png": "8292",
	"./theme_gold/images/icon-download.png": "5225",
	"./theme_gold/images/icon-edit-dark.png": "2296",
	"./theme_gold/images/icon-edit-fill.png": "5f84",
	"./theme_gold/images/icon-expand-w.png": "d1e6",
	"./theme_gold/images/icon-favorite-active.png": "6a1d",
	"./theme_gold/images/icon-favorite.png": "afeb",
	"./theme_gold/images/icon-filter.png": "b706",
	"./theme_gold/images/icon-flag.png": "3935",
	"./theme_gold/images/icon-game-search.png": "0bec",
	"./theme_gold/images/icon-home.png": "7304",
	"./theme_gold/images/icon-info.png": "13d5",
	"./theme_gold/images/icon-invite-bonus.png": "80151",
	"./theme_gold/images/icon-invite-promo.png": "aeda",
	"./theme_gold/images/icon-invite-weekly.png": "e0d4",
	"./theme_gold/images/icon-kyc-add.png": "814a",
	"./theme_gold/images/icon-kyc-close.png": "3f94",
	"./theme_gold/images/icon-kyc-open.png": "f957",
	"./theme_gold/images/icon-lock.png": "c9ed",
	"./theme_gold/images/icon-member-active.png": "5ee8",
	"./theme_gold/images/icon-member.png": "a63d",
	"./theme_gold/images/icon-nav-home.png": "0544",
	"./theme_gold/images/icon-news-w.png": "1d7b",
	"./theme_gold/images/icon-notice.png": "3323",
	"./theme_gold/images/icon-password.png": "5876",
	"./theme_gold/images/icon-phone-active.png": "3b9d",
	"./theme_gold/images/icon-phone.png": "c6fe",
	"./theme_gold/images/icon-qrcode.png": "b3df",
	"./theme_gold/images/icon-real-name.png": "bc12",
	"./theme_gold/images/icon-recommend.png": "01f3",
	"./theme_gold/images/icon-refresh.png": "6426",
	"./theme_gold/images/icon-register-success.png": "b335",
	"./theme_gold/images/icon-search.png": "735c",
	"./theme_gold/images/icon-slot-select.png": "d9bcc",
	"./theme_gold/images/icon-slot.png": "9e01",
	"./theme_gold/images/icon-top-arrow.svg": "f7c8",
	"./theme_gold/images/icon-usdt.png": "8ff3",
	"./theme_gold/images/icon_alert.png": "60a2",
	"./theme_gold/images/icon_allgames.png": "7079",
	"./theme_gold/images/icon_awesome_bitcoin.png": "bdb6",
	"./theme_gold/images/icon_bell.png": "9dd8",
	"./theme_gold/images/icon_bonus.svg": "2d74",
	"./theme_gold/images/icon_calendar_light.png": "e6bd",
	"./theme_gold/images/icon_card_light.png": "980f",
	"./theme_gold/images/icon_check_white.png": "ac67",
	"./theme_gold/images/icon_close.png": "7374",
	"./theme_gold/images/icon_copy_regular.png": "c28e",
	"./theme_gold/images/icon_copy_white.png": "428d5",
	"./theme_gold/images/icon_download_white.png": "3ec2",
	"./theme_gold/images/icon_email.png": "becd",
	"./theme_gold/images/icon_ig.png": "d816",
	"./theme_gold/images/icon_img_01.png": "f154",
	"./theme_gold/images/icon_img_03.png": "0f71",
	"./theme_gold/images/icon_img_04.png": "ab60",
	"./theme_gold/images/icon_img_05.png": "cbeb",
	"./theme_gold/images/icon_img_06.png": "ecc1",
	"./theme_gold/images/icon_img_07.png": "74cc",
	"./theme_gold/images/icon_img_08.png": "abc5",
	"./theme_gold/images/icon_img_09.png": "93e2",
	"./theme_gold/images/icon_img_10.png": "620a",
	"./theme_gold/images/icon_img_11.png": "b86d",
	"./theme_gold/images/icon_img_12.png": "d245",
	"./theme_gold/images/icon_img_13.png": "aebc",
	"./theme_gold/images/icon_img_14.png": "c0f5",
	"./theme_gold/images/icon_img_15.png": "384f",
	"./theme_gold/images/icon_japan.png": "40fc",
	"./theme_gold/images/icon_jpy.png": "4674",
	"./theme_gold/images/icon_jpy.svg": "cd57",
	"./theme_gold/images/icon_lock_light.png": "8422",
	"./theme_gold/images/icon_metro_credit_card.png": "1727",
	"./theme_gold/images/icon_payment_bankomat.png": "ca5d",
	"./theme_gold/images/icon_promo_check.png": "1ee0",
	"./theme_gold/images/icon_promo_check_v2.png": "7b00",
	"./theme_gold/images/icon_shield_gray.png": "c7ef",
	"./theme_gold/images/icon_simple_electron.png": "00ec",
	"./theme_gold/images/icon_tab_favorite.png": "20a5",
	"./theme_gold/images/icon_tag_hot.png": "ac63",
	"./theme_gold/images/icon_tag_new.png": "0dde",
	"./theme_gold/images/icon_tag_noBonus.png": "f329",
	"./theme_gold/images/icon_trash.png": "9471",
	"./theme_gold/images/icon_twitter.png": "fe57",
	"./theme_gold/images/icon_uestion.svg": "4731",
	"./theme_gold/images/icon_usd.svg": "fbc8",
	"./theme_gold/images/icon_user_light.png": "e0f6",
	"./theme_gold/images/icon_youtube.png": "a7a4",
	"./theme_gold/images/image-bank.png": "3fdc",
	"./theme_gold/images/image-upload.png": "efe2",
	"./theme_gold/images/instruction.png": "2a26",
	"./theme_gold/images/iocn-trash-fill.png": "cb4a",
	"./theme_gold/images/japan.png": "3686",
	"./theme_gold/images/jp-yen.svg": "19ca",
	"./theme_gold/images/jp_logo.png": "930c",
	"./theme_gold/images/leave.png": "3876",
	"./theme_gold/images/lights_m.png": "bcac",
	"./theme_gold/images/live.png": "cf51",
	"./theme_gold/images/login-left-2.jpg": "95f1",
	"./theme_gold/images/login-left.jpg": "5ea3",
	"./theme_gold/images/login-left.png": "f4e9",
	"./theme_gold/images/login-logo-2-mb.jpg": "6628",
	"./theme_gold/images/login-logo.jpg": "caca",
	"./theme_gold/images/logo-2.webp": "25a0",
	"./theme_gold/images/logo.png": "bbcd",
	"./theme_gold/images/logo_ft.png": "d16c",
	"./theme_gold/images/logo_katsuwin.png": "c293",
	"./theme_gold/images/lpfv-pc-2000.png": "73b4",
	"./theme_gold/images/lpfv-pc-3000.png": "b437",
	"./theme_gold/images/lpfv-pc-4000.png": "6ed0",
	"./theme_gold/images/lpfv-pc-5000.png": "2f2f",
	"./theme_gold/images/lpfv-pc.png": "2e36",
	"./theme_gold/images/lpfv-sp-2000.png": "8a83",
	"./theme_gold/images/lpfv-sp-3000.png": "5a9e",
	"./theme_gold/images/lpfv-sp-4000.png": "9de3",
	"./theme_gold/images/lpfv-sp-5000.png": "b1db",
	"./theme_gold/images/lpfv-sp.png": "040e",
	"./theme_gold/images/main_bg.jpg": "9deb",
	"./theme_gold/images/mall-invite-image.png": "26be",
	"./theme_gold/images/mall-product-image.png": "d8be",
	"./theme_gold/images/money_pop.png": "b7b7",
	"./theme_gold/images/monthly-bonus.png": "88c4",
	"./theme_gold/images/monyback-gold.svg": "63c5",
	"./theme_gold/images/monyback-icon.svg": "1513",
	"./theme_gold/images/my-account.png": "88ef",
	"./theme_gold/images/my_kyc_ex1.png": "c235",
	"./theme_gold/images/my_kyc_ex2.webp": "aa91",
	"./theme_gold/images/nav-bottom-deposit-active.png": "5a42",
	"./theme_gold/images/nav-bottom-deposit.png": "bc5a",
	"./theme_gold/images/nav-bottom-game-active.png": "7561",
	"./theme_gold/images/nav-bottom-game.png": "3824",
	"./theme_gold/images/nav-bottom-home-active.png": "d640",
	"./theme_gold/images/nav-bottom-home-mobile-index.png": "fb75",
	"./theme_gold/images/nav-bottom-home.png": "65e1",
	"./theme_gold/images/nav-bottom-my-active.png": "65c9",
	"./theme_gold/images/nav-bottom-my.png": "c4fe",
	"./theme_gold/images/nav-bottom-offers-active.png": "3854",
	"./theme_gold/images/nav-bottom-offers.png": "47f51",
	"./theme_gold/images/nav-bottom-toggle.png": "c337",
	"./theme_gold/images/new_guide.png": "32ff",
	"./theme_gold/images/no-data.png": "9c8b",
	"./theme_gold/images/no.svg": "ef64",
	"./theme_gold/images/oncasy_logo.png": "55c9",
	"./theme_gold/images/pachislot.png": "54a9",
	"./theme_gold/images/personal_data_ad.png": "9c4e",
	"./theme_gold/images/program.png": "f10a",
	"./theme_gold/images/rank-1st.png": "05eb",
	"./theme_gold/images/rank-2nd.png": "8429",
	"./theme_gold/images/rank-3rd.png": "0128",
	"./theme_gold/images/rebate-bonus.png": "7dc9",
	"./theme_gold/images/register-bg.jpg": "dc80",
	"./theme_gold/images/register-logo-pc.jpg": "9db7",
	"./theme_gold/images/register-logo.jpg": "48f5",
	"./theme_gold/images/register-logo.png": "569a",
	"./theme_gold/images/registration-2000.png": "631e",
	"./theme_gold/images/registration-3000.png": "7728",
	"./theme_gold/images/registration-4000.png": "7530",
	"./theme_gold/images/registration-5000.png": "4f3e",
	"./theme_gold/images/registration.png": "7840",
	"./theme_gold/images/shop.png": "b51c",
	"./theme_gold/images/skill.png": "065d",
	"./theme_gold/images/slots.png": "da60",
	"./theme_gold/images/spin_wheel_bg_lt.png": "9952",
	"./theme_gold/images/spin_wheel_bg_rt.png": "cd50",
	"./theme_gold/images/stake-logo.png": "039f",
	"./theme_gold/images/structure01.png": "9d7b",
	"./theme_gold/images/structure01.svg": "e843",
	"./theme_gold/images/structure02.png": "ac4c",
	"./theme_gold/images/structure02.svg": "ccfc",
	"./theme_gold/images/structure03.png": "ad6a",
	"./theme_gold/images/structure03.svg": "767f",
	"./theme_gold/images/sup/account_mb_01.jpg": "6b10",
	"./theme_gold/images/sup/account_mb_02.jpg": "6492",
	"./theme_gold/images/sup/account_mb_03.jpg": "9d3f",
	"./theme_gold/images/sup/account_mb_03.png": "1f73",
	"./theme_gold/images/sup/account_mb_04.jpg": "04fb",
	"./theme_gold/images/sup/account_mb_05.jpg": "693d",
	"./theme_gold/images/sup/account_pc_01.png": "8452",
	"./theme_gold/images/sup/account_pc_02.png": "a174",
	"./theme_gold/images/sup/account_pc_03.png": "4e7a",
	"./theme_gold/images/sup/account_pc_04.webp": "050f",
	"./theme_gold/images/sup/account_pc_05.png": "b1b8",
	"./theme_gold/images/sup/account_pc_06.png": "0f15",
	"./theme_gold/images/sup/account_pc_07.png": "dd3a",
	"./theme_gold/images/sup/account_pc_08.png": "1e33",
	"./theme_gold/images/sup/binding_mb_tab_01.png": "7300",
	"./theme_gold/images/sup/binding_mb_tab_02.png": "5f89",
	"./theme_gold/images/sup/binding_mb_tab_03.png": "3846",
	"./theme_gold/images/sup/binding_mb_tab_04.png": "3c2d",
	"./theme_gold/images/sup/binding_mb_tab_05.png": "c0c5",
	"./theme_gold/images/sup/binding_mb_tab_06.png": "e364",
	"./theme_gold/images/sup/binding_pc_tab_01.png": "5e35",
	"./theme_gold/images/sup/binding_pc_tab_02.png": "b9f3",
	"./theme_gold/images/sup/binding_pc_tab_03.png": "cc8c",
	"./theme_gold/images/sup/binding_pc_tab_04.png": "a632",
	"./theme_gold/images/sup/binding_pc_tab_05.png": "9799",
	"./theme_gold/images/sup/binding_pc_tab_06.png": "7be0",
	"./theme_gold/images/sup/confirmID_2-2.webp": "e8d4",
	"./theme_gold/images/sup/coupon_mb_tab_01.png": "9d4a",
	"./theme_gold/images/sup/coupon_mb_tab_02.png": "7111",
	"./theme_gold/images/sup/coupon_pc_tab_01.png": "e605",
	"./theme_gold/images/sup/coupon_pc_tab_02.png": "ec74",
	"./theme_gold/images/sup/event_mb_tab_01.png": "35d22",
	"./theme_gold/images/sup/event_mb_tab_02.png": "a656",
	"./theme_gold/images/sup/event_mb_tab_03.png": "9b42",
	"./theme_gold/images/sup/event_pc_tab_01.png": "466d",
	"./theme_gold/images/sup/event_pc_tab_02.png": "7ded",
	"./theme_gold/images/sup/event_pc_tab_03.png": "6e85",
	"./theme_gold/images/sup/login_tab01_01.png": "4c3c",
	"./theme_gold/images/sup/login_tab01_02.png": "4e58",
	"./theme_gold/images/sup/login_tab01_03.png": "3baf",
	"./theme_gold/images/sup/login_tab01_04.png": "84c7",
	"./theme_gold/images/sup/login_tab01_05.png": "0828",
	"./theme_gold/images/sup/login_tab02_02.png": "fcf8",
	"./theme_gold/images/sup/login_tab02_03.png": "2a37",
	"./theme_gold/images/sup/login_tab02_04.png": "f922",
	"./theme_gold/images/sup/login_tab02_05.png": "7219",
	"./theme_gold/images/sup/login_tab03_01.png": "162e",
	"./theme_gold/images/sup/login_tab03_02.png": "a51c",
	"./theme_gold/images/sup/login_tab03_03.png": "7b3c",
	"./theme_gold/images/sup/login_tab03_04.png": "fe16",
	"./theme_gold/images/sup/login_tab03_05.png": "6142",
	"./theme_gold/images/sup/login_tab04_02.png": "3107",
	"./theme_gold/images/sup/login_tab04_03.png": "0b7b",
	"./theme_gold/images/sup/login_tab04_04.png": "43d2",
	"./theme_gold/images/sup/login_tab04_05.png": "97b5",
	"./theme_gold/images/sup/payment_mb_01.png": "82ad",
	"./theme_gold/images/sup/payment_mb_02.png": "bb0f",
	"./theme_gold/images/sup/payment_mb_03.png": "daa3",
	"./theme_gold/images/sup/payment_mb_04.png": "aba6",
	"./theme_gold/images/sup/payment_mb_05.png": "e6e3",
	"./theme_gold/images/sup/payment_mb_06.png": "1d65",
	"./theme_gold/images/sup/payment_mb_07.png": "cb86",
	"./theme_gold/images/sup/payment_mb_08.png": "2e45",
	"./theme_gold/images/sup/payment_mb_09.png": "7d2b",
	"./theme_gold/images/sup/payment_mb_10.png": "c004",
	"./theme_gold/images/sup/payment_mb_11.png": "ce16",
	"./theme_gold/images/sup/payment_pc_01.png": "905c",
	"./theme_gold/images/sup/payment_pc_02.png": "a1ed",
	"./theme_gold/images/sup/payment_pc_03.png": "ed03",
	"./theme_gold/images/sup/payment_pc_04.png": "eef8",
	"./theme_gold/images/sup/payment_pc_05.png": "f8e3",
	"./theme_gold/images/sup/payment_pc_06.png": "fd8a",
	"./theme_gold/images/sup/payment_pc_07.png": "551e",
	"./theme_gold/images/sup/payment_pc_08.png": "4cb7",
	"./theme_gold/images/sup/payment_pc_09.png": "2ca3",
	"./theme_gold/images/sup/payment_pc_10.png": "774d",
	"./theme_gold/images/sup/payment_pc_11.png": "a772",
	"./theme_gold/images/sup/payment_pc_12.png": "bdd6",
	"./theme_gold/images/sup/pc_banner_sup_acc.webp": "62b4",
	"./theme_gold/images/sup/pc_banner_sup_accout.webp": "4dba",
	"./theme_gold/images/sup/pc_banner_sup_coupon.webp": "df20",
	"./theme_gold/images/sup/pc_banner_sup_event.webp": "b795",
	"./theme_gold/images/sup/pc_banner_sup_faq.webp": "246c",
	"./theme_gold/images/sup/pc_banner_sup_faq_k.webp": "5a98",
	"./theme_gold/images/sup/pc_banner_sup_login.webp": "874c",
	"./theme_gold/images/sup/pc_banner_sup_pay.webp": "ec76",
	"./theme_gold/images/sup/pc_banner_sup_recommend.webp": "5c10",
	"./theme_gold/images/sup/pc_banner_sup_responsible.webp": "e5e1",
	"./theme_gold/images/sup/pc_banner_sup_shop.webp": "edef",
	"./theme_gold/images/sup/pc_banner_sup_vip.webp": "3da7",
	"./theme_gold/images/sup/pc_banner_sup_wallet.webp": "63e5",
	"./theme_gold/images/sup/recommended_01.webp": "a090",
	"./theme_gold/images/sup/recommended_02.webp": "1a82",
	"./theme_gold/images/sup/recommended_03.webp": "ac68",
	"./theme_gold/images/sup/recommended_04.webp": "73af",
	"./theme_gold/images/sup/recommended_05.webp": "2552",
	"./theme_gold/images/sup/register_mb_01.png": "1e3e",
	"./theme_gold/images/sup/register_mb_02.png": "f5d5",
	"./theme_gold/images/sup/register_mb_03.png": "7321",
	"./theme_gold/images/sup/register_mb_04.png": "3965",
	"./theme_gold/images/sup/register_mb_05.png": "7f1a",
	"./theme_gold/images/sup/register_pc_01.png": "95c8",
	"./theme_gold/images/sup/register_pc_02.png": "724b",
	"./theme_gold/images/sup/register_pc_03.png": "4996",
	"./theme_gold/images/sup/register_pc_04.png": "cf85",
	"./theme_gold/images/sup/register_pc_05.png": "6ead",
	"./theme_gold/images/sup/shop_mb_tab_01.png": "0aca",
	"./theme_gold/images/sup/shop_mb_tab_02.png": "6ab9",
	"./theme_gold/images/sup/shop_pc_tab_01.png": "96e2",
	"./theme_gold/images/sup/shop_pc_tab_02.png": "3afa",
	"./theme_gold/images/sup/table.png": "112d",
	"./theme_gold/images/sup/vip_mb_tab_01.png": "fbd7",
	"./theme_gold/images/sup/vip_mb_tab_02.png": "5e2d",
	"./theme_gold/images/sup/vip_mb_tab_03.png": "8c80",
	"./theme_gold/images/sup/vip_pc_tab_01.png": "4f7b",
	"./theme_gold/images/sup/vip_pc_tab_02.png": "b8ee",
	"./theme_gold/images/sup/wallet_mb_01.png": "f2cf",
	"./theme_gold/images/sup/wallet_mb_02.png": "e2f4",
	"./theme_gold/images/sup/wallet_mb_03.png": "1c8c",
	"./theme_gold/images/sup/wallet_mb_04.png": "9b3b",
	"./theme_gold/images/sup/wallet_mb_05.png": "ed58",
	"./theme_gold/images/sup/wallet_mb_06.png": "60b2",
	"./theme_gold/images/sup/wallet_pc_01.png": "ad88",
	"./theme_gold/images/sup/wallet_pc_02.png": "a184",
	"./theme_gold/images/sup/wallet_pc_03.png": "1320",
	"./theme_gold/images/sup/wallet_pc_04.png": "2d6a",
	"./theme_gold/images/sup/wallet_pc_05.png": "2b1c",
	"./theme_gold/images/sup/wallet_pc_06.png": "91fcd",
	"./theme_gold/images/sup/wallet_pc_07.png": "56f7",
	"./theme_gold/images/sup/wallet_pc_08.png": "dbae",
	"./theme_gold/images/terms-bg.png": "fa81",
	"./theme_gold/images/title-championship.png": "579d",
	"./theme_gold/images/top10-bn.png": "c73d",
	"./theme_gold/images/top10-bn2.png": "273b",
	"./theme_gold/images/top_up.png": "20d1",
	"./theme_gold/images/trophy-gold.svg": "6d69",
	"./theme_gold/images/trophy-icon.svg": "257d",
	"./theme_gold/images/useful_link/agent_five.webp": "06a1",
	"./theme_gold/images/useful_link/agent_four.webp": "60b9",
	"./theme_gold/images/useful_link/agent_one.webp": "5fcc",
	"./theme_gold/images/useful_link/agent_three.webp": "b6ed",
	"./theme_gold/images/useful_link/agent_two.webp": "7dd3",
	"./theme_gold/images/useful_link/agent_validSeal.webp": "7f9e",
	"./theme_gold/images/useful_link/bg.jpg": "0a16",
	"./theme_gold/images/useful_link/bonusIntroducing.webp": "48b3",
	"./theme_gold/images/useful_link/how_to_join_1.webp": "190a",
	"./theme_gold/images/useful_link/how_to_join_2.webp": "3180",
	"./theme_gold/images/useful_link/how_to_join_3.webp": "59ec",
	"./theme_gold/images/useful_link/icon_FAQ.png": "7cef",
	"./theme_gold/images/useful_link/icon_account_binding.png": "679f",
	"./theme_gold/images/useful_link/icon_confirm_method.png": "bfc0",
	"./theme_gold/images/useful_link/icon_coupon.png": "8f9f",
	"./theme_gold/images/useful_link/icon_deposit_withdraw.png": "6942",
	"./theme_gold/images/useful_link/icon_event_bonus.png": "9679",
	"./theme_gold/images/useful_link/icon_login.png": "5314",
	"./theme_gold/images/useful_link/icon_login_method.png": "b8c0",
	"./theme_gold/images/useful_link/icon_recommended_games.png": "8068",
	"./theme_gold/images/useful_link/icon_self_restriction.png": "cd56",
	"./theme_gold/images/useful_link/icon_shop.png": "089f",
	"./theme_gold/images/useful_link/icon_vip_class_upgrading.png": "13d8",
	"./theme_gold/images/useful_link/icon_wallet.png": "50f2",
	"./theme_gold/images/useful_link/pc_banner_agent.jpeg": "b993",
	"./theme_gold/images/useful_link/pc_banner_cookie.jpeg": "e535",
	"./theme_gold/images/useful_link/pc_banner_cooperation.jpeg": "e93e",
	"./theme_gold/images/useful_link/pc_banner_cooperation.jpg": "7647",
	"./theme_gold/images/useful_link/pc_banner_privacy.jpeg": "b597",
	"./theme_gold/images/useful_link/pc_banner_rule.jpeg": "0a61",
	"./theme_gold/images/useful_link/pc_banner_sport.jpeg": "91a1",
	"./theme_gold/images/useful_link/pc_banner_support.jpeg": "7cdc",
	"./theme_gold/images/useful_link/pc_banner_support.png": "2c56",
	"./theme_gold/images/useful_link/pc_banner_terms.png": "6782",
	"./theme_gold/images/useful_link/permanentIncome.webp": "bf25",
	"./theme_gold/images/vector.svg": "e980",
	"./theme_gold/images/verify.png": "8b0d",
	"./theme_gold/images/vip-24-hours.png": "2c23",
	"./theme_gold/images/vip-arrow-left.png": "48da",
	"./theme_gold/images/vip-arrow-right.png": "275d",
	"./theme_gold/images/vip-bg.jpg": "9c2b",
	"./theme_gold/images/vip-bonus.png": "fd24",
	"./theme_gold/images/vip-coin-stack.png": "33135",
	"./theme_gold/images/vip-crown.png": "265a",
	"./theme_gold/images/vip-green-line.png": "c6ff",
	"./theme_gold/images/vip-roulette.png": "3807",
	"./theme_gold/images/vip-wallet.png": "9cc2",
	"./theme_gold/images/vip.png": "ab9f",
	"./theme_gold/images/vip_bg.jpg": "f21c",
	"./theme_gold/images/vip_bg.png": "29c8",
	"./theme_gold/images/vip_gift_bg.png": "5e7b",
	"./theme_gold/images/wallet.png": "480d",
	"./theme_gold/images/web_TOP.png": "7399",
	"./theme_gold/images/weekly-bonus.png": "7c32",
	"./theme_gold/images/wheel_2x.png": "598a",
	"./theme_gold/variables.css": "822c",
	"./theme_purple/images/9_gift.png": "9620",
	"./theme_purple/images/Angle-left-g.png": "c35c",
	"./theme_purple/images/Angle-left.png": "8328",
	"./theme_purple/images/Angle-right-g.png": "bf76",
	"./theme_purple/images/Angle-right.png": "f48f",
	"./theme_purple/images/BarbarianFury.png": "47f2",
	"./theme_purple/images/BattleDwarfXmas.png": "28fe",
	"./theme_purple/images/BoatBonanzaDownUnder.png": "4b29",
	"./theme_purple/images/DragonKingHotPots.png": "5cca",
	"./theme_purple/images/Ellipse.png": "f122",
	"./theme_purple/images/H5_TOP.jpg": "cab4",
	"./theme_purple/images/HawaiianDreamXmas.png": "6894",
	"./theme_purple/images/LogoLoading_circle01.png": "9d88",
	"./theme_purple/images/LogoLoading_circle02.png": "fe3e",
	"./theme_purple/images/LogoLoading_katsu.png": "f518",
	"./theme_purple/images/OiranDreamXmas.png": "a0e9",
	"./theme_purple/images/PyramidRisingx33.png": "b92a",
	"./theme_purple/images/RichWildeandtheTomeofInsanity.png": "d365",
	"./theme_purple/images/SparkofGenius.png": "67a4",
	"./theme_purple/images/Starstruck.png": "727a",
	"./theme_purple/images/TheGoldenOwlofAthena.png": "6342",
	"./theme_purple/images/TheSwordandtheGrailExcalibur.png": "1b75",
	"./theme_purple/images/Withdraw-gold.svg": "6d90",
	"./theme_purple/images/Withdraw-icon.svg": "5e35f",
	"./theme_purple/images/about_bg04.png": "a171",
	"./theme_purple/images/add.svg": "9851",
	"./theme_purple/images/affiliates.png": "a90a",
	"./theme_purple/images/bankB-gold.svg": "5f25",
	"./theme_purple/images/bankB-icon.svg": "e7b2",
	"./theme_purple/images/bg-masthead-mb.png": "768c",
	"./theme_purple/images/bg-masthead.png": "2764",
	"./theme_purple/images/bg_brush.png": "ff56",
	"./theme_purple/images/bg_repeat.png": "2121",
	"./theme_purple/images/bg_top.png": "e622",
	"./theme_purple/images/birth-bonus.png": "6768",
	"./theme_purple/images/bitcoin-btc-gold.svg": "91e1",
	"./theme_purple/images/bitcoin-btc-logo.svg": "8a60",
	"./theme_purple/images/blog.png": "ea59",
	"./theme_purple/images/bullhorn.svg": "cbe8",
	"./theme_purple/images/cach-gold.svg": "d280",
	"./theme_purple/images/cach-icon.svg": "d020",
	"./theme_purple/images/card-gold.svg": "b1e4",
	"./theme_purple/images/card-icon.svg": "fd19",
	"./theme_purple/images/ch_logo.png": "b1e7",
	"./theme_purple/images/championship-bg.jpg": "3935e",
	"./theme_purple/images/championship-main-event-bg.jpg": "69d7",
	"./theme_purple/images/check-on.png": "f436",
	"./theme_purple/images/cn_logo.png": "48f1",
	"./theme_purple/images/collect.png": "f563",
	"./theme_purple/images/collect_full.png": "a2de",
	"./theme_purple/images/comments-question.svg": "86b2",
	"./theme_purple/images/completed.png": "df87",
	"./theme_purple/images/creditcard-back.png": "5980",
	"./theme_purple/images/creditcard-front.png": "3913",
	"./theme_purple/images/crypto-ada.svg": "f98c",
	"./theme_purple/images/crypto-bch.svg": "714d",
	"./theme_purple/images/crypto-bnb.svg": "4585",
	"./theme_purple/images/crypto-btc.svg": "c23d",
	"./theme_purple/images/crypto-cny.svg": "f836",
	"./theme_purple/images/crypto-dai.svg": "7b8b",
	"./theme_purple/images/crypto-doge.svg": "11c5",
	"./theme_purple/images/crypto-eos.svg": "d6b8",
	"./theme_purple/images/crypto-eth.svg": "3a05",
	"./theme_purple/images/crypto-jpy.svg": "ac61",
	"./theme_purple/images/crypto-ltc.svg": "24ee",
	"./theme_purple/images/crypto-shib.svg": "eef2",
	"./theme_purple/images/crypto-teth.svg": "0cf0",
	"./theme_purple/images/crypto-trx.svg": "4965",
	"./theme_purple/images/crypto-twd.svg": "f2b0",
	"./theme_purple/images/crypto-usd.svg": "7198",
	"./theme_purple/images/crypto-usdc.svg": "1da6",
	"./theme_purple/images/crypto-usdt.svg": "f119",
	"./theme_purple/images/crypto-xrp.svg": "047c",
	"./theme_purple/images/daily-attend.png": "d9dd",
	"./theme_purple/images/db_gift_left.png": "6fe1",
	"./theme_purple/images/db_gift_right.png": "5179",
	"./theme_purple/images/db_hero_img_mb.png": "23d3",
	"./theme_purple/images/db_hero_img_pc.png": "b1c8",
	"./theme_purple/images/db_icon_coin.png": "6e39",
	"./theme_purple/images/db_icon_lock.png": "ce9c",
	"./theme_purple/images/default-crypto.svg": "f4f7",
	"./theme_purple/images/deposit-gold.svg": "83d5",
	"./theme_purple/images/deposit-icon.svg": "c43a",
	"./theme_purple/images/dot-dk.svg": "a37f",
	"./theme_purple/images/dot-orange.svg": "ef21",
	"./theme_purple/images/dot.svg": "7990",
	"./theme_purple/images/dw.png": "d5ae",
	"./theme_purple/images/electron-gold.svg": "c95d",
	"./theme_purple/images/electron-icon.svg": "ed69",
	"./theme_purple/images/email.svg": "dcc2",
	"./theme_purple/images/en_logo.png": "9c72",
	"./theme_purple/images/event.png": "3490",
	"./theme_purple/images/event_specail_deposit_bg3.png": "5e89",
	"./theme_purple/images/favorite.png": "85c1",
	"./theme_purple/images/footer_gaming1.png": "79ca",
	"./theme_purple/images/footer_gaming2.png": "ee8a",
	"./theme_purple/images/footer_gaming3.png": "fa7c",
	"./theme_purple/images/footer_gaming4.png": "1035",
	"./theme_purple/images/fortunewheel.png": "f0bd",
	"./theme_purple/images/friend_promo.png": "fcff",
	"./theme_purple/images/giftbox.png": "1fac",
	"./theme_purple/images/headset.png": "5850",
	"./theme_purple/images/heart-line.svg": "9bb3",
	"./theme_purple/images/heart.svg": "44c2",
	"./theme_purple/images/history.png": "d5a1",
	"./theme_purple/images/home-arrow-left.png": "5134",
	"./theme_purple/images/home-arrow-right.png": "217b",
	"./theme_purple/images/icon-account.png": "aac8",
	"./theme_purple/images/icon-add.png": "9e9f",
	"./theme_purple/images/icon-alert-kyc.png": "de6b",
	"./theme_purple/images/icon-alert.png": "87dd",
	"./theme_purple/images/icon-arrow-down-2.png": "08d6",
	"./theme_purple/images/icon-arrow-down-3.png": "2b49",
	"./theme_purple/images/icon-arrow-down-4-disabled.png": "e99e",
	"./theme_purple/images/icon-arrow-down-4.png": "5c27",
	"./theme_purple/images/icon-arrow-down-gold.png": "42ab",
	"./theme_purple/images/icon-arrow-down.png": "2706",
	"./theme_purple/images/icon-arrow-dropdown.png": "6006",
	"./theme_purple/images/icon-arrow-right.png": "a10c",
	"./theme_purple/images/icon-arrow-rightx2.png": "19a7",
	"./theme_purple/images/icon-check-black.png": "4352",
	"./theme_purple/images/icon-check.png": "d5bd",
	"./theme_purple/images/icon-checked.png": "74ab",
	"./theme_purple/images/icon-close-black.png": "adc2",
	"./theme_purple/images/icon-close.png": "cfc9",
	"./theme_purple/images/icon-close_index_phone.png": "cd99",
	"./theme_purple/images/icon-coin.png": "f09a",
	"./theme_purple/images/icon-copy-2.png": "085e",
	"./theme_purple/images/icon-copy.png": "84ff",
	"./theme_purple/images/icon-credit.png": "898f",
	"./theme_purple/images/icon-crown.png": "486e",
	"./theme_purple/images/icon-date.png": "1d01",
	"./theme_purple/images/icon-detail.png": "ae08",
	"./theme_purple/images/icon-diamond.png": "6b55",
	"./theme_purple/images/icon-download.png": "fae2",
	"./theme_purple/images/icon-edit-dark.png": "303f",
	"./theme_purple/images/icon-edit-fill.png": "d07b",
	"./theme_purple/images/icon-expand-w.png": "0b92",
	"./theme_purple/images/icon-favorite-active.png": "2d24",
	"./theme_purple/images/icon-favorite.png": "1342",
	"./theme_purple/images/icon-filter.png": "cf86",
	"./theme_purple/images/icon-flag.png": "c6d9",
	"./theme_purple/images/icon-game-search.png": "4c57",
	"./theme_purple/images/icon-home.png": "6739",
	"./theme_purple/images/icon-info.png": "b870",
	"./theme_purple/images/icon-invite-bonus.png": "39cc",
	"./theme_purple/images/icon-invite-promo.png": "8035",
	"./theme_purple/images/icon-invite-weekly.png": "e296",
	"./theme_purple/images/icon-kyc-add.png": "52ad",
	"./theme_purple/images/icon-kyc-close.png": "384c",
	"./theme_purple/images/icon-kyc-open.png": "a6322",
	"./theme_purple/images/icon-lock.png": "5158",
	"./theme_purple/images/icon-member-active.png": "d6cf",
	"./theme_purple/images/icon-member.png": "16ac",
	"./theme_purple/images/icon-nav-home.png": "1fef",
	"./theme_purple/images/icon-news-w.png": "1094",
	"./theme_purple/images/icon-notice.png": "13ed",
	"./theme_purple/images/icon-password.png": "edb4",
	"./theme_purple/images/icon-phone-active.png": "ae68",
	"./theme_purple/images/icon-phone.png": "81f0",
	"./theme_purple/images/icon-qrcode.png": "b9c1",
	"./theme_purple/images/icon-real-name.png": "a361",
	"./theme_purple/images/icon-recommend.png": "8dd6",
	"./theme_purple/images/icon-refresh.png": "1c63",
	"./theme_purple/images/icon-register-success.png": "33af",
	"./theme_purple/images/icon-search.png": "bd39",
	"./theme_purple/images/icon-slot-select.png": "273d",
	"./theme_purple/images/icon-slot.png": "0eb5",
	"./theme_purple/images/icon-top-arrow.svg": "52e0",
	"./theme_purple/images/icon-usdt.png": "c5327",
	"./theme_purple/images/icon_alert.png": "24db",
	"./theme_purple/images/icon_allgames.png": "0f1d",
	"./theme_purple/images/icon_awesome_bitcoin.png": "81d8",
	"./theme_purple/images/icon_bell.png": "a4f1",
	"./theme_purple/images/icon_bonus.svg": "a044",
	"./theme_purple/images/icon_calendar_light.png": "fdf1",
	"./theme_purple/images/icon_card_light.png": "205e",
	"./theme_purple/images/icon_check_white.png": "d480",
	"./theme_purple/images/icon_close.png": "e4d1",
	"./theme_purple/images/icon_copy_regular.png": "8868",
	"./theme_purple/images/icon_copy_white.png": "f60a",
	"./theme_purple/images/icon_download_white.png": "2013",
	"./theme_purple/images/icon_email.png": "0ed8",
	"./theme_purple/images/icon_ig.png": "1100",
	"./theme_purple/images/icon_img_01.png": "9b6c",
	"./theme_purple/images/icon_img_03.png": "dbf3",
	"./theme_purple/images/icon_img_04.png": "8a78",
	"./theme_purple/images/icon_img_05.png": "5dbd",
	"./theme_purple/images/icon_img_06.png": "a059",
	"./theme_purple/images/icon_img_07.png": "b78b",
	"./theme_purple/images/icon_img_08.png": "d310",
	"./theme_purple/images/icon_img_09.png": "c21c",
	"./theme_purple/images/icon_img_10.png": "28db",
	"./theme_purple/images/icon_img_11.png": "5f47",
	"./theme_purple/images/icon_img_12.png": "2740a",
	"./theme_purple/images/icon_img_13.png": "4a03",
	"./theme_purple/images/icon_img_14.png": "1ee3",
	"./theme_purple/images/icon_img_15.png": "c9c1",
	"./theme_purple/images/icon_japan.png": "658a",
	"./theme_purple/images/icon_jpy.png": "1b7e",
	"./theme_purple/images/icon_jpy.svg": "900e",
	"./theme_purple/images/icon_lock_light.png": "2bfb",
	"./theme_purple/images/icon_metro_credit_card.png": "4c33",
	"./theme_purple/images/icon_payment_bankomat.png": "d5b2",
	"./theme_purple/images/icon_promo_check.png": "8eb5",
	"./theme_purple/images/icon_promo_check_v2.png": "fd46",
	"./theme_purple/images/icon_shield_gray.png": "d67a",
	"./theme_purple/images/icon_simple_electron.png": "0a8f",
	"./theme_purple/images/icon_tab_favorite.png": "406b",
	"./theme_purple/images/icon_tag_hot.png": "1623",
	"./theme_purple/images/icon_tag_new.png": "569d",
	"./theme_purple/images/icon_tag_noBonus.png": "ea4c",
	"./theme_purple/images/icon_trash.png": "6081",
	"./theme_purple/images/icon_twitter.png": "4457",
	"./theme_purple/images/icon_uestion.svg": "edc0",
	"./theme_purple/images/icon_usd.svg": "97ce",
	"./theme_purple/images/icon_user_light.png": "7a32",
	"./theme_purple/images/icon_youtube.png": "f8c0",
	"./theme_purple/images/image-bank.png": "9215",
	"./theme_purple/images/image-upload.png": "00de",
	"./theme_purple/images/instruction.png": "598d",
	"./theme_purple/images/iocn-trash-fill.png": "77f7",
	"./theme_purple/images/japan.png": "4335",
	"./theme_purple/images/jp-yen.svg": "076f",
	"./theme_purple/images/jp_logo.png": "5fef",
	"./theme_purple/images/leave.png": "c05f",
	"./theme_purple/images/lights_m.png": "1fd4",
	"./theme_purple/images/live.png": "8d8a",
	"./theme_purple/images/login-left-2.jpg": "6633",
	"./theme_purple/images/login-left.jpg": "a384",
	"./theme_purple/images/login-left.png": "b6f2",
	"./theme_purple/images/login-logo-2-mb.jpg": "a1d1",
	"./theme_purple/images/login-logo.jpg": "0015",
	"./theme_purple/images/logo-2.webp": "d4fc",
	"./theme_purple/images/logo.png": "7995",
	"./theme_purple/images/logo_ft.png": "aa9d",
	"./theme_purple/images/logo_katsuwin.png": "3177",
	"./theme_purple/images/lpfv-pc-2000.png": "c238",
	"./theme_purple/images/lpfv-pc-3000.png": "83e0",
	"./theme_purple/images/lpfv-pc-4000.png": "dc0e",
	"./theme_purple/images/lpfv-pc-5000.png": "8d66",
	"./theme_purple/images/lpfv-pc.png": "4028",
	"./theme_purple/images/lpfv-sp-2000.png": "cece",
	"./theme_purple/images/lpfv-sp-3000.png": "46eb",
	"./theme_purple/images/lpfv-sp-4000.png": "b372",
	"./theme_purple/images/lpfv-sp-5000.png": "aae3",
	"./theme_purple/images/lpfv-sp.png": "b135",
	"./theme_purple/images/main_bg.jpg": "99a9",
	"./theme_purple/images/mall-invite-image.png": "28e8",
	"./theme_purple/images/mall-product-image.png": "c053",
	"./theme_purple/images/money_pop.png": "8d29",
	"./theme_purple/images/monthly-bonus.png": "c48d",
	"./theme_purple/images/monyback-gold.svg": "82bf",
	"./theme_purple/images/monyback-icon.svg": "fa4e",
	"./theme_purple/images/my-account.png": "6325",
	"./theme_purple/images/my_kyc_ex1.png": "e9ce",
	"./theme_purple/images/my_kyc_ex2.webp": "4c70",
	"./theme_purple/images/nav-bottom-deposit-active.png": "d203",
	"./theme_purple/images/nav-bottom-deposit.png": "367e",
	"./theme_purple/images/nav-bottom-game-active.png": "a605",
	"./theme_purple/images/nav-bottom-game.png": "1c57",
	"./theme_purple/images/nav-bottom-home-active.png": "d8519",
	"./theme_purple/images/nav-bottom-home-mobile-index.png": "c31d",
	"./theme_purple/images/nav-bottom-home.png": "2e73",
	"./theme_purple/images/nav-bottom-my-active.png": "187c",
	"./theme_purple/images/nav-bottom-my.png": "2bbd",
	"./theme_purple/images/nav-bottom-offers-active.png": "53bc",
	"./theme_purple/images/nav-bottom-offers.png": "ceeb",
	"./theme_purple/images/nav-bottom-toggle.png": "126d",
	"./theme_purple/images/new_guide.png": "a2d6",
	"./theme_purple/images/no-data.png": "058e",
	"./theme_purple/images/no.svg": "325f",
	"./theme_purple/images/oncasy_logo.png": "b491",
	"./theme_purple/images/pachislot.png": "1b57",
	"./theme_purple/images/personal_data_ad.png": "8b50",
	"./theme_purple/images/program.png": "264a",
	"./theme_purple/images/rank-1st.png": "537d",
	"./theme_purple/images/rank-2nd.png": "e9bc",
	"./theme_purple/images/rank-3rd.png": "5e43",
	"./theme_purple/images/rebate-bonus.png": "a1f0",
	"./theme_purple/images/register-bg.jpg": "4b10",
	"./theme_purple/images/register-logo-pc.jpg": "6eaf",
	"./theme_purple/images/register-logo.jpg": "159b",
	"./theme_purple/images/register-logo.png": "4ce8",
	"./theme_purple/images/registration-2000.png": "6cdf",
	"./theme_purple/images/registration-3000.png": "f967",
	"./theme_purple/images/registration-4000.png": "301b",
	"./theme_purple/images/registration-5000.png": "4db3",
	"./theme_purple/images/registration.png": "5ff4",
	"./theme_purple/images/shop.png": "6d8f",
	"./theme_purple/images/skill.png": "87b5",
	"./theme_purple/images/slots.png": "e986",
	"./theme_purple/images/spin_wheel_bg_lt.png": "e33d",
	"./theme_purple/images/spin_wheel_bg_rt.png": "4864",
	"./theme_purple/images/stake-logo.png": "1229",
	"./theme_purple/images/structure01.png": "0b04",
	"./theme_purple/images/structure01.svg": "44a4",
	"./theme_purple/images/structure02.png": "ae46",
	"./theme_purple/images/structure02.svg": "cc7b",
	"./theme_purple/images/structure03.png": "c641",
	"./theme_purple/images/structure03.svg": "0687",
	"./theme_purple/images/sup/account_mb_01.jpg": "a24f",
	"./theme_purple/images/sup/account_mb_02.jpg": "1eda",
	"./theme_purple/images/sup/account_mb_03.jpg": "1b4f",
	"./theme_purple/images/sup/account_mb_03.png": "3c6e",
	"./theme_purple/images/sup/account_mb_04.jpg": "c028",
	"./theme_purple/images/sup/account_mb_05.jpg": "9e5b",
	"./theme_purple/images/sup/account_pc_01.png": "8151",
	"./theme_purple/images/sup/account_pc_02.png": "4c66",
	"./theme_purple/images/sup/account_pc_03.png": "8625",
	"./theme_purple/images/sup/account_pc_04.webp": "b5b5",
	"./theme_purple/images/sup/account_pc_05.png": "2d41",
	"./theme_purple/images/sup/account_pc_06.png": "d85a",
	"./theme_purple/images/sup/account_pc_07.png": "779b",
	"./theme_purple/images/sup/account_pc_08.png": "d5e5",
	"./theme_purple/images/sup/binding_mb_tab_01.png": "5f44",
	"./theme_purple/images/sup/binding_mb_tab_02.png": "7970",
	"./theme_purple/images/sup/binding_mb_tab_03.png": "c6c6",
	"./theme_purple/images/sup/binding_mb_tab_04.png": "7f95",
	"./theme_purple/images/sup/binding_mb_tab_05.png": "11c57",
	"./theme_purple/images/sup/binding_mb_tab_06.png": "60cf",
	"./theme_purple/images/sup/binding_pc_tab_01.png": "594e",
	"./theme_purple/images/sup/binding_pc_tab_02.png": "b398",
	"./theme_purple/images/sup/binding_pc_tab_03.png": "47e2",
	"./theme_purple/images/sup/binding_pc_tab_04.png": "17d5",
	"./theme_purple/images/sup/binding_pc_tab_05.png": "bf3f",
	"./theme_purple/images/sup/binding_pc_tab_06.png": "3ae2",
	"./theme_purple/images/sup/confirmID_2-2.webp": "9372",
	"./theme_purple/images/sup/coupon_mb_tab_01.png": "721b",
	"./theme_purple/images/sup/coupon_mb_tab_02.png": "c03a",
	"./theme_purple/images/sup/coupon_pc_tab_01.png": "50d9",
	"./theme_purple/images/sup/coupon_pc_tab_02.png": "cf48",
	"./theme_purple/images/sup/event_mb_tab_01.png": "fd60",
	"./theme_purple/images/sup/event_mb_tab_02.png": "8264",
	"./theme_purple/images/sup/event_mb_tab_03.png": "ce168",
	"./theme_purple/images/sup/event_pc_tab_01.png": "b285",
	"./theme_purple/images/sup/event_pc_tab_02.png": "9991",
	"./theme_purple/images/sup/event_pc_tab_03.png": "cef3",
	"./theme_purple/images/sup/login_tab01_01.png": "88b9",
	"./theme_purple/images/sup/login_tab01_02.png": "0dc8",
	"./theme_purple/images/sup/login_tab01_03.png": "0510",
	"./theme_purple/images/sup/login_tab01_04.png": "369e",
	"./theme_purple/images/sup/login_tab01_05.png": "e41e",
	"./theme_purple/images/sup/login_tab02_02.png": "2089",
	"./theme_purple/images/sup/login_tab02_03.png": "ee89",
	"./theme_purple/images/sup/login_tab02_04.png": "a803",
	"./theme_purple/images/sup/login_tab02_05.png": "3945",
	"./theme_purple/images/sup/login_tab03_01.png": "833e",
	"./theme_purple/images/sup/login_tab03_02.png": "5b40",
	"./theme_purple/images/sup/login_tab03_03.png": "373e",
	"./theme_purple/images/sup/login_tab03_04.png": "6c26",
	"./theme_purple/images/sup/login_tab03_05.png": "50a3",
	"./theme_purple/images/sup/login_tab04_02.png": "5e36",
	"./theme_purple/images/sup/login_tab04_03.png": "eb4c",
	"./theme_purple/images/sup/login_tab04_04.png": "2fea",
	"./theme_purple/images/sup/login_tab04_05.png": "5165",
	"./theme_purple/images/sup/payment_mb_01.png": "3f45",
	"./theme_purple/images/sup/payment_mb_02.png": "3f8d",
	"./theme_purple/images/sup/payment_mb_03.png": "677c",
	"./theme_purple/images/sup/payment_mb_04.png": "a8a5",
	"./theme_purple/images/sup/payment_mb_05.png": "ec0f",
	"./theme_purple/images/sup/payment_mb_06.png": "055e",
	"./theme_purple/images/sup/payment_mb_07.png": "a53c",
	"./theme_purple/images/sup/payment_mb_08.png": "01282",
	"./theme_purple/images/sup/payment_mb_09.png": "b63a",
	"./theme_purple/images/sup/payment_mb_10.png": "fdb2",
	"./theme_purple/images/sup/payment_mb_11.png": "8067",
	"./theme_purple/images/sup/payment_pc_01.png": "2661",
	"./theme_purple/images/sup/payment_pc_02.png": "12d7",
	"./theme_purple/images/sup/payment_pc_03.png": "0cc6",
	"./theme_purple/images/sup/payment_pc_04.png": "e32f",
	"./theme_purple/images/sup/payment_pc_05.png": "847f",
	"./theme_purple/images/sup/payment_pc_06.png": "0f2d",
	"./theme_purple/images/sup/payment_pc_07.png": "7320",
	"./theme_purple/images/sup/payment_pc_08.png": "6ae4",
	"./theme_purple/images/sup/payment_pc_09.png": "3b93",
	"./theme_purple/images/sup/payment_pc_10.png": "b3c0",
	"./theme_purple/images/sup/payment_pc_11.png": "9790",
	"./theme_purple/images/sup/payment_pc_12.png": "ee22",
	"./theme_purple/images/sup/pc_banner_sup_acc.webp": "39a4",
	"./theme_purple/images/sup/pc_banner_sup_accout.webp": "ec3d",
	"./theme_purple/images/sup/pc_banner_sup_coupon.webp": "8f38",
	"./theme_purple/images/sup/pc_banner_sup_event.webp": "d67d",
	"./theme_purple/images/sup/pc_banner_sup_faq.webp": "d3e6",
	"./theme_purple/images/sup/pc_banner_sup_faq_k.webp": "c2387",
	"./theme_purple/images/sup/pc_banner_sup_login.webp": "fef1",
	"./theme_purple/images/sup/pc_banner_sup_pay.webp": "947a",
	"./theme_purple/images/sup/pc_banner_sup_recommend.webp": "2aaf",
	"./theme_purple/images/sup/pc_banner_sup_responsible.webp": "fb5a",
	"./theme_purple/images/sup/pc_banner_sup_shop.webp": "4270",
	"./theme_purple/images/sup/pc_banner_sup_vip.webp": "1834",
	"./theme_purple/images/sup/pc_banner_sup_wallet.webp": "d89d",
	"./theme_purple/images/sup/recommended_01.webp": "d139",
	"./theme_purple/images/sup/recommended_02.webp": "5afa",
	"./theme_purple/images/sup/recommended_03.webp": "6697",
	"./theme_purple/images/sup/recommended_04.webp": "67b4",
	"./theme_purple/images/sup/recommended_05.webp": "ccf8",
	"./theme_purple/images/sup/register_mb_01.png": "1d5d",
	"./theme_purple/images/sup/register_mb_02.png": "8b21",
	"./theme_purple/images/sup/register_mb_03.png": "88f0",
	"./theme_purple/images/sup/register_mb_04.png": "cad2",
	"./theme_purple/images/sup/register_mb_05.png": "e96b",
	"./theme_purple/images/sup/register_pc_01.png": "8fe2",
	"./theme_purple/images/sup/register_pc_02.png": "5ea6",
	"./theme_purple/images/sup/register_pc_03.png": "27db",
	"./theme_purple/images/sup/register_pc_04.png": "254c",
	"./theme_purple/images/sup/register_pc_05.png": "dbd7",
	"./theme_purple/images/sup/shop_mb_tab_01.png": "be26",
	"./theme_purple/images/sup/shop_mb_tab_02.png": "9883",
	"./theme_purple/images/sup/shop_pc_tab_01.png": "c174",
	"./theme_purple/images/sup/shop_pc_tab_02.png": "3dab",
	"./theme_purple/images/sup/table.png": "a2cf",
	"./theme_purple/images/sup/vip_mb_tab_01.png": "51d5",
	"./theme_purple/images/sup/vip_mb_tab_02.png": "e5c4",
	"./theme_purple/images/sup/vip_mb_tab_03.png": "9e1b",
	"./theme_purple/images/sup/vip_pc_tab_01.png": "f280",
	"./theme_purple/images/sup/vip_pc_tab_02.png": "9729",
	"./theme_purple/images/sup/wallet_mb_01.png": "9ad58",
	"./theme_purple/images/sup/wallet_mb_02.png": "9afa",
	"./theme_purple/images/sup/wallet_mb_03.png": "3f60",
	"./theme_purple/images/sup/wallet_mb_04.png": "3737",
	"./theme_purple/images/sup/wallet_mb_05.png": "8ee8",
	"./theme_purple/images/sup/wallet_mb_06.png": "b032",
	"./theme_purple/images/sup/wallet_pc_01.png": "897c",
	"./theme_purple/images/sup/wallet_pc_02.png": "fc87",
	"./theme_purple/images/sup/wallet_pc_03.png": "f006",
	"./theme_purple/images/sup/wallet_pc_04.png": "f5c6",
	"./theme_purple/images/sup/wallet_pc_05.png": "aa26",
	"./theme_purple/images/sup/wallet_pc_06.png": "0686",
	"./theme_purple/images/sup/wallet_pc_07.png": "22c5",
	"./theme_purple/images/sup/wallet_pc_08.png": "8540",
	"./theme_purple/images/terms-bg.png": "45eb",
	"./theme_purple/images/title-championship.png": "10c9",
	"./theme_purple/images/top10-bn.png": "5ba3",
	"./theme_purple/images/top10-bn2.png": "fd14",
	"./theme_purple/images/top_up.png": "1d04",
	"./theme_purple/images/trophy-gold.svg": "0e2a",
	"./theme_purple/images/trophy-icon.svg": "7690",
	"./theme_purple/images/useful_link/agent_five.webp": "8391",
	"./theme_purple/images/useful_link/agent_four.webp": "1db4",
	"./theme_purple/images/useful_link/agent_one.webp": "6e90",
	"./theme_purple/images/useful_link/agent_three.webp": "2e5f",
	"./theme_purple/images/useful_link/agent_two.webp": "b517",
	"./theme_purple/images/useful_link/agent_validSeal.webp": "292d",
	"./theme_purple/images/useful_link/bg.jpg": "b044",
	"./theme_purple/images/useful_link/bonusIntroducing.webp": "893f",
	"./theme_purple/images/useful_link/how_to_join_1.webp": "a254",
	"./theme_purple/images/useful_link/how_to_join_2.webp": "cff1",
	"./theme_purple/images/useful_link/how_to_join_3.webp": "ac2b",
	"./theme_purple/images/useful_link/icon_FAQ.png": "a6a5",
	"./theme_purple/images/useful_link/icon_account_binding.png": "bc9c",
	"./theme_purple/images/useful_link/icon_confirm_method.png": "2e00",
	"./theme_purple/images/useful_link/icon_coupon.png": "a984",
	"./theme_purple/images/useful_link/icon_deposit_withdraw.png": "b37d",
	"./theme_purple/images/useful_link/icon_event_bonus.png": "5026",
	"./theme_purple/images/useful_link/icon_login.png": "c73f",
	"./theme_purple/images/useful_link/icon_login_method.png": "a00d",
	"./theme_purple/images/useful_link/icon_recommended_games.png": "fb6d",
	"./theme_purple/images/useful_link/icon_self_restriction.png": "159d",
	"./theme_purple/images/useful_link/icon_shop.png": "d53a",
	"./theme_purple/images/useful_link/icon_vip_class_upgrading.png": "abc8",
	"./theme_purple/images/useful_link/icon_wallet.png": "f65d",
	"./theme_purple/images/useful_link/pc_banner_agent.jpeg": "a143",
	"./theme_purple/images/useful_link/pc_banner_cookie.jpeg": "dad2",
	"./theme_purple/images/useful_link/pc_banner_cooperation.jpeg": "72eb",
	"./theme_purple/images/useful_link/pc_banner_cooperation.jpg": "f460",
	"./theme_purple/images/useful_link/pc_banner_privacy.jpeg": "0ce1",
	"./theme_purple/images/useful_link/pc_banner_rule.jpeg": "91d3",
	"./theme_purple/images/useful_link/pc_banner_sport.jpeg": "3832",
	"./theme_purple/images/useful_link/pc_banner_support.jpeg": "5256",
	"./theme_purple/images/useful_link/pc_banner_support.png": "27c1",
	"./theme_purple/images/useful_link/pc_banner_terms.png": "f383",
	"./theme_purple/images/useful_link/permanentIncome.webp": "4d1e",
	"./theme_purple/images/vector.svg": "6085",
	"./theme_purple/images/verify.png": "ea40",
	"./theme_purple/images/vip-24-hours.png": "4224",
	"./theme_purple/images/vip-arrow-left.png": "cc53",
	"./theme_purple/images/vip-arrow-right.png": "ffff",
	"./theme_purple/images/vip-bg.jpg": "1fad",
	"./theme_purple/images/vip-bonus.png": "f823",
	"./theme_purple/images/vip-coin-stack.png": "73d8",
	"./theme_purple/images/vip-crown.png": "52e8",
	"./theme_purple/images/vip-green-line.png": "617d",
	"./theme_purple/images/vip-roulette.png": "12da",
	"./theme_purple/images/vip-wallet.png": "70bd",
	"./theme_purple/images/vip.png": "7440",
	"./theme_purple/images/vip_bg.jpg": "41a3",
	"./theme_purple/images/vip_bg.png": "3049",
	"./theme_purple/images/vip_gift_bg.png": "ff7f",
	"./theme_purple/images/wallet.png": "e2dd",
	"./theme_purple/images/web_TOP.png": "b278",
	"./theme_purple/images/weekly-bonus.png": "e01d",
	"./theme_purple/images/wheel_2x.png": "1ab2",
	"./theme_purple/variables.css": "4ba6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";